<div [ngClass]="gridLayoutClassNames()">
    @for (column of board().columns; track column) {
    <div class="dashboard-grid">
        @for (card of column.cards; track card) {
            <eas-board-card-renderer class="dashboard-grid__card" [card]="card" />
        }
    </div>
    }
</div>
